export { default as Button } from './Button/index.js';
export { default as ButtonGroup } from './ButtonGroup/index.js';
export { default as CircularProgress } from './CircularProgress/index.js';
export { default as FocusTrap } from './FocusTrap/index.js';
export { default as ConfirmModal } from './ConfirmModal/index.js';
export { S as SyncInputAutocomplete } from '../SyncInputAutocomplete-OAI9zAiZ.js';
export { L as LazyLoad } from '../LazyLoad-ZXaED2gd.js';
export { default as Loader } from './Loader/index.js';
export { default as LoginForm } from './LoginForm/index.js';
export { default as RegisterForm } from './RegisterForm/index.js';
export { R as RegisterPage } from '../RegisterPage-PJoeEjMv.js';
export { default as ForgotPasswordForm } from './ForgotPasswordForm/index.js';
export { F as ForgotPasswordPage } from '../ForgotPasswordPage--Fu1w_Ea.js';
export { default as ResetPasswordForm } from './ResetPasswordForm/index.js';
export { R as ResetPasswordPage } from '../ResetPasswordPage-A51j2s6F.js';
export { default as LoginPage } from './LoginPage/index.js';
export { N as Navigation } from '../Navigation-GJsgPaMK.js';
export { O as Orders } from '../Orders-TvemnPcb.js';
export { O as Order } from '../Order-TqMgZI2f.js';
export { A as Address } from '../Address-9-Qapn-u.js';
export { default as Category } from './Category/index.js';
export { C as CategoryHeader } from '../CategoryHeader-s-kLV-J5.js';
export { C as CategorySEO } from '../CategorySEO-5I-hA5gp.js';
export { default as Product } from './Product/index.js';
export { C as Counter } from '../Counter-5i0zX3vz.js';
export { I as ItemCopy } from '../ItemCopy-ybQM05eF.js';
export { O as OptionsForm } from '../OptionsForm-7SjF9TsL.js';
export { R as RelatedProducts } from '../RelatedProducts-wOAHevPP.js';
export { U as UpsellProducts } from '../UpsellProducts-Wc3lCklO.js';
export { S as SimpleProduct } from '../SimpleProduct-AzgxASLz.js';
export { P as Prices } from '../Prices-J1SqTpik.js';
export { default as MiniShoppingCart } from './MiniShoppingCart/index.js';
export { M as MiniShoppingCartContent } from '../MiniShoppingCartContent-tZZmT1oa.js';
export { default as ShoppingCartDrawer } from './CartDrawer/index.js';
export { S as CartDrawerButton } from '../CartDrawerButton-2eYmUV78.js';
export { default as Help } from './Help/index.js';
export { default as ContactUs } from './Help/ContactUs/index.js';
export { default as Search } from './Search/index.js';
export { S as SearchDrawer } from '../SearchDrawer-D8UjrtYF.js';
export { N as NavigationMenu } from '../NavigationMenu-ewPKe50j.js';
export { D as Drawer } from '../Drawer-6ip5pbu5.js';
export { S as Settings } from '../Settings-gix97lFK.js';
export { default as Wishlist } from './Wishlist/index.js';
export { S as ShoppingCart } from '../ShoppingCart-vV9LqRTr.js';
import React, { useRef, useState, useEffect, useContext } from 'react';
import { CoreContext } from '../context/index.js';
import 'react-i18next';
import 'notistack';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import '../utils/logToSlack.js';
import 'lodash/get';
import '../product-_pRduMz7.js';
import 'lodash/cloneDeep';
import '../helpers-kA_hdoOI.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-YC9H491Y.js';
import 'lodash';
import 'graphql-request';
import '../utils/currency.js';
import '../utils/price.js';
import '../animations--PMkOS0j.js';
import '../index-sNwiaBfD.js';
import 'react-hook-form';
import './ShoppingCart/ShoppingCartContentDrawer/ShoppingCartItemDrawer/Quantity/QuantityForm/form/index.js';
import { c as classnames } from '../index-2586sEvh.js';
import 'lodash/debounce';
export { default as IconButton } from './IconButton/index.js';
import '../store/modal/index.js';
export { F as FeaturedProducts } from '../FeaturedProducts-ZgE3Sm-3.js';
export { C as Checkout } from '../Checkout--pdJc5gJ.js';
export { F as FailureOrder } from '../FailureOrder-gYpxIF-G.js';
export { F as FailureOrderDefault } from '../FailureOrderDefault-Gy9Avpbl.js';
export { M as ManualOrder } from '../ManualOrder-ODQ1zLGa.js';
export { P as ProcessHCResult } from '../ProcessHCResult-LONNrd4z.js';
export { S as SuccessOrder } from '../SuccessOrder-L9rTJKQQ.js';
export { T as ThankYouOrder } from '../ThankYouOrder-2xvdxXt5.js';
export { H as Header } from '../Header-59uo6hGc.js';
export { S as SiteLinks } from '../SiteLinks-lubG-7tj.js';
export { A as AuthSidebar } from '../AuthSidebar-Xo6yBtAt.js';
export { L as Logo } from '../Logo-fy1HhiD6.js';
import { S as SignUpUpdatesForm } from '../SignUpUpdatesForm-sCD9ZWje.js';
import useWindowSize from '../hooks/useWindowSize.js';
import useUserInteractionEvent from '../hooks/useUserInteractionEvent.js';
export { E as ErrorPage } from '../ErrorPage-hsjsOFEm.js';
import Link from './Link/index.js';
import logger from '../utils/logger.js';
import { w as withProviders } from '../withProviders-l3mjYkR2.js';
import { C as ConditionalWrapper } from '../ConditionalWrapper-6zYfwfM_.js';
import useShowError from '../hooks/useShowError.js';
export { P as PageOops } from '../PageOops-wufRoYq_.js';
export { P as PageMaintenance } from '../PageMaintenance-iWNOIvs_.js';
export { P as Page404 } from '../Page404-4293xKbg.js';
export { N as NextHead } from '../NextHead-828BS7ON.js';
export { N as NextPage } from '../NextPage-snxYPxxI.js';
export { E as ErrorBoundary } from '../ErrorBoundary-h_wvb6tU.js';
export { S as ServerError } from '../ServerError-Hh6GMB4h.js';
export { C as CurrencyDrawer } from '../CurrencyDrawer-i0qWs87Y.js';
export { L as LanguageDrawer } from '../LanguageDrawer-4WcXsbB1.js';
export { A as Account } from '../Account-3nqM-VIn.js';
export { B as Banner } from '../Banner-hHc_G3rw.js';
export { B as BannerWrapper } from '../BannerWrapper-injZHySf.js';
export { F as FirstVisitModal } from '../FirstVisitModal-vgp__D35.js';
export { default as CartRebuild } from './CartRebuild/index.js';
import '../_commonjsHelpers-jjO7Zipk.js';
import 'next/link';
import './Modal/index.js';
import './OnlyUIRender/index.js';
import './Modal/ModalContent/index.js';
import 'react-dom';
import '../hooks/useAutoFocus.js';
import '../hooks/useGetPortalRoot.js';
import '../utils/portalRoot.js';
import './Modal/ModalHeader/index.js';
import '../index-RkBJ48Nr.js';
import 'i18next';
import '../index-_7uIHHAF.js';
import '../utils/product.js';
import '../paths-ZKN3m62_.js';
import '../cookies-l-jEMp6P.js';
import '../hooks/useOutsideClick.js';
import '../hooks/useOutsideFocus.js';
import './EmptyMessage/index.js';
import '../SyncAutocompleteOption-6NxOjkam.js';
import '../TextHighlighter-ZyVmLG-I.js';
import '../AutoSelect-L0O_tgq1.js';
import '../hooks/useOnScreen.js';
import '../storeSelectors/email.js';
import '../utils/salesforce.js';
import '../utils/cookies.js';
import '../utils/isBot.js';
import '../utils/cart.js';
import '../MergeCarts-wo9UjKo5.js';
import '../ProcessReactivateCart-fk5bSKoR.js';
import '../requestsCollection-gritD79O.js';
import '../services/auth/index.js';
import '../utils/fetchPolicyLookup.js';
import '../cart-Vtx0Wqgk.js';
import '../serverErrors-_VHsjhgw.js';
import '../utils/error.js';
import '../utils/logToRelic.js';
import 'number-currency-format';
import '../hooks/useCaptcha.js';
import '../storeSelectors/captcha.js';
import '../hooks/useShowNotify.js';
import './LoginForm/form/index.js';
import 'yup';
import '@hookform/resolvers/yup';
import '../utils/validation.js';
import '../validation-AjMAVn7m.js';
import '../Input-quQLghm0.js';
import '../InputPassword-SnmSpVSN.js';
import '../HCaptcha-z_AMrNS9.js';
import '@hcaptcha/react-hcaptcha';
import '../GetHCaptchaToken-sJpm0bg0.js';
import './RegisterForm/form/index.js';
import '../types/index.js';
import '../checkout-Ee1eEXQH.js';
import '../menu-0TyOg98i.js';
import '../modal-6vnX5SO3.js';
import '../Checkbox-o9DWtxXo.js';
import '@reduxjs/toolkit';
import '../services/newsletter/index.js';
import '../utils/date.js';
import 'date-fns';
import '../hooks/usePasswordMatch.js';
import '../utils/captcha.js';
import './ForgotPasswordForm/form/index.js';
import '../RequestPasswordResetEmail-sI5OAj7X.js';
import './ResetPasswordForm/form/index.js';
import '../ResetPasswordQuery-M30aDjHm.js';
import '../account-o8FpsAAZ.js';
import '../ItemSkeleton-RZ9lOAMj.js';
import '../Skeleton-RKr5mJai.js';
import '../Item-GU2o05OL.js';
import '../utils/checkout.js';
import '../localStorage-h6SlcHvK.js';
import '../ItemHeader-0dHTfjeQ.js';
import '../index.es-4eaw7_IJ.js';
import '../GetOrdersList-HoCPNP13.js';
import '../OrderSkeleton-6cdijR3Y.js';
import '../ItemsList-1Oicw2VJ.js';
import '../utils/image.js';
import '../Details-DYDESbJ8.js';
import '../Prices-dU3zJggX.js';
import '../utils/shipping.js';
import '../AddressListWrapper-vEJamwor.js';
import '../AddressSkeleton-8JVuns-f.js';
import '../AddressList-RdprKjXP.js';
import '../AddressItem-NKim8ClO.js';
import '../EditAddress-W9EJZhrp.js';
import '../utils/common.js';
import '../AddressForm--ItRdwGU.js';
import '../index-zHauh-tC.js';
import '../index-hQxnpQRT.js';
import 'lodash/find';
import '../utils/address.js';
import '../validationSchema-ULew-NpY.js';
import '../AddAddress-80gLoHOY.js';
import './Address/AddressForm/form/index.js';
import '../utils/category.js';
import '../GetCategoryBanner-6p0nM8yz.js';
import '../GetCategoryYmals-iaGgJ2fD.js';
import '../UrlResolver-yh_X8hA9.js';
import './Breadcrumbs/index.js';
import '../CategoryItem-5BT4-v-e.js';
import '../utils/saleFlag.js';
import '../SaleFlag-uqbhEU3Y.js';
import '../ProductItem-Yen9IyVx.js';
import '../selectItem-PWuzvZX7.js';
import '../hooks/useItemListName.js';
import '../utils/dataRouteFormat.js';
import '../ColorSwitcher-33YjEBxV.js';
import '../RadioGroup-ZDexyLRv.js';
import '../RadioButton-vqcFktHg.js';
import '../ScreenDetector-Q3qjZIcS.js';
import './WishlistButton/index.js';
import '../storeSelectors/user.js';
import '../storeSelectors/wishlist.js';
import './JustAddedProducts/index.js';
import '../ShopButton-3jX2bKPw.js';
import '../selectItem-UJ5YRly2.js';
import '../CategoryBanner-Jp_beYYn.js';
import '../hooks/useAnimate.js';
import '../store/modal/initialState.js';
import '../ConfigurableProduct-9Jn0sipD.js';
import '../helper-qZTqmbEO.js';
import './ImagesCarousel/index.js';
import '../Carousel-wPZBp8CD.js';
import '../a11y-f6LwtRzd.js';
import '../breakpoints-X1SKRYyW.js';
import '../Lightbox-qa-xYGH2.js';
import '../ImagesCarouselVertical-b9BRMREW.js';
import '../EcoFee-Ep6rIIu6.js';
import '../storeSelectors/currencies.js';
import '../ItemTabs-PRQx9xWO.js';
import '../ItemsAccordion-b0XndCSS.js';
import '../ScrollToPlugin-k_fMCFg8.js';
import 'lodash/pickBy';
import 'lodash/set';
import 'lodash/mergeWith';
import 'lodash/isEqual';
import '../index-NdDXdXEk.js';
import './InfoVariantModal/index.js';
import '../Table-LdWI5rGH.js';
import '../Gallery-lGbUPTvY.js';
import '../SizeChart-PqebL4MS.js';
import '../ColorField-c502EpZi.js';
import '../Colors-Kgh-lUHw.js';
import '../SizeField-JNtoYwfb.js';
import '../Sizes-tn0Bbk4S.js';
import '../Select-LSn3KQwG.js';
import '../AlmaBanner-qWjGjPhU.js';
import '../storeSelectors/cart.js';
import '../hooks/useHoverIntent.js';
import '../cart-SVV9q5Ln.js';
import '../cart-bEN0otWy.js';
import '../MiniShoppingCartSkeleton-U6EZ6VaK.js';
import '../ItemSkeleton-03cEVH7e.js';
import '../MiniShoppingCartItem-UKpWU5t6.js';
import '../storeSelectors/ymal.js';
import '../validationSchema-SF-U2-Ri.js';
import '../ShoppingCartDrawer-JkxWuPvo.js';
import '../ShoppingCartContentDrawer-zsXS-TJp.js';
import '../checkout-lyccjd9h.js';
import '../ShoppingCartItemDrawer-fo_umU3A.js';
import '../Quantity-CBiGIFk6.js';
import '../QuantityForm-nYHoHPeB.js';
import './inputs/InputQuantity/index.js';
import './inputs/AutoSubmit/index.js';
import '../Remove-yBvNmlSV.js';
import '../ShoppingCartDrawerSkeleton-kCFrECX9.js';
import '../CartItemDrawerSkeleton-pSF-OxYE.js';
import '../hooks/usePageViewEvent.js';
import '../pageView-EPLyidHy.js';
import '../utils/auth.js';
import '../storeSelectors/category.js';
import '../storeSelectors/product.js';
import '../FeaturedProductItem-3H1owsmv.js';
import '../SwiperActions-zQ1VhslW.js';
import '../FeaturedProductSkeleton-dpwqH2FM.js';
import '../featuredProducts-00rJtoMw.js';
import '../types-nwm8HIz7.js';
import '../Navigation-yXC39IfA.js';
import '../Item-Z13RNFMm.js';
import '../Content-7EOS_2d5.js';
import 'react-dom/server';
import '../ShippingChart-WhG8PR2C.js';
import '../BedShippingChart-5Mamjyyj.js';
import '../ContactUsForm-EzwFTXVg.js';
import './Help/ContactUs/ContactUsForm/form/index.js';
import '../Textarea-CrVLRrCI.js';
import '../services/graphql/help/index.js';
import '../SearchSkeleton-JP_koZc6.js';
import '../ResultsList-qPol6FqB.js';
import '../search-GFXtShlL.js';
import '../InfiniteList-765ajZUe.js';
import '../Product--XMXdbli.js';
import '../search-3gNCPr7T.js';
import '../NothingFound-ka_l9cNI.js';
import './Search/NothingFound/form/index.js';
import './inputs/Input/index.js';
import '../Search-KLaacfX3.js';
import './QuickSearch/index.js';
import './QuickSearch/form/index.js';
import '../InputAutocomplete-21f02xiu.js';
import '../InputAutocompleteOption-ZBLmHamR.js';
import '../QuickSearch-ab76fizv.js';
import '../Menu-Ts194RYs.js';
import '../MenuItem-Dn2z2gAG.js';
import '../SubMenu-3IxuijNo.js';
import '../MenuItem-p_VGbV0y.js';
import '../utils/userClickHandler.js';
import '../MenuMobile-fBQzq5K-.js';
import '../MenuItem-tjmskPE4.js';
import '../SubMenu-9iwuv3hI.js';
import '../MenuItem-ap5gxdWe.js';
import '../AccountInformationForm-3BZm4Ekg.js';
import './Settings/AccountInformationForm/form/index.js';
import '../FormSkeleton-MBYlNU56.js';
import '../UpdateCustomerData-6yW6gpPs.js';
import '../ChangePasswordForm-c2MV1-k4.js';
import './Settings/ChangePasswordForm/form/index.js';
import '../ChangeCustomerPassword-OopVc78P.js';
import '../WishlistSkeleton-DAAgLdct.js';
import './Wishlist/Product/index.js';
import '../DeleteWishlistProduct-bgfod7ME.js';
import '../ShoppingCartContent-ORLBYbgs.js';
import '../ShoppingCartItem-Lx1U2CzC.js';
import '../Quantity-tY9dHFs-.js';
import '../QuantityForm-KqiI42Bu.js';
import './ShoppingCart/ShoppingCartContent/ShoppingCartItem/Quantity/QuantityForm/form/index.js';
import '../Remove-G9I9crrw.js';
import '../ShoppingCartSkeleton-0Sd_272Z.js';
import '../CartItemSkeleton-1fPCLe-_.js';
import '../storeSelectors/checkout.js';
import '../checkout-a3CXaCwx.js';
import '../subscription-blf7SMVl.js';
import '../PaymentMethodsList-tvD7NGjL.js';
import '../hooks/useIsAppleDevice.js';
import '../hooks/useIsMobileOrTablet.js';
import '../hooks/useIsSafari.js';
import '../ExpressPayment-3f5CeLuP.js';
import '../CheckoutBlock-cVI3slpn.js';
import '../ExpressPaymentSkeleton-Ji14fmiO.js';
import '../ExpressPaymentContent-wEr11aoh.js';
import '../Paypal-I8-P9yDM.js';
import '../react-paypal-js-IByS2wWO.js';
import '../GooglePay-lkmjdlq4.js';
import '../index-P5NzM2H1.js';
import '../CustomerInfo-68oKrQLZ.js';
import '../CustomerInfoSkeleton-AVZanb0S.js';
import '../CustomerInfoContent-8sqMgkA_.js';
import '../PreviewEmail-5er6YfxU.js';
import '../EditEmail-hb_fhrTK.js';
import '../utils/user.js';
import './Checkout/components/CustomerInfo/CustomerInfoContent/EditEmail/form/index.js';
import '../validationSchema-iEeC4u80.js';
import '../IsEmailAvailable-S1lboUSk.js';
import '../ShippingAndBilling-UCJPgszA.js';
import '../ShippingAndBillingSkeleton-LyZD4vtP.js';
import '../ShippingAndBillingContent-iLiSdUZD.js';
import '../helper-KRodnqMa.js';
import '../Shipping-bpk67SXj.js';
import '../AddressBook-Po3nAlMi.js';
import './Checkout/components/ShippingAndBilling/ShippingAndBillingContent/components/AddressBook/form/index.js';
import '../validationSchema-HkYDInDm.js';
import '../AddressPreview-2QVp87sJ.js';
import '../AddressForm-9w_b7shv.js';
import '../validationSchema-3C4XtDiU.js';
import './Checkout/components/ShippingAndBilling/ShippingAndBillingContent/components/AddressForm/form/index.js';
import '../Billing-5n8CIRvh.js';
import '../ShippingFees-OFGTrI8j.js';
import '../ShippingFeesSkeleton-sdBxZ9HA.js';
import '../ShippingFeesContent-wxfHFqVG.js';
import '../helper-kxgjrFUh.js';
import '../PaymentMethod-G7csCM5x.js';
import '../PaymentMethodSkeleton-d92oi5kn.js';
import '../PaymentMethodContent-TeFW0C9H.js';
import '../ValidationBlock-Vmzoywof.js';
import '../Order-J3LBsDnw.js';
import '../OrderContent-5ouf5qpW.js';
import '../OrderItem-AohIprkM.js';
import '../OrderSkeleton-ooMO3rwR.js';
import '../OrderItemSkeleton-RWFKm7TI.js';
import '../BedMattressRemoval-UQmpJVZd.js';
import '../OutOfStock-qbdyYeD4.js';
import '../OrderAgreement-84l-ildR.js';
import '../BedAndMattressModal-5CMh3m-W.js';
import '../PromoCode-4wEMI9f9.js';
import '../ApplyCoupon-ubUPRaBR.js';
import './Checkout/components/PromoCode/ApplyCoupon/form/index.js';
import '../validationSchema-w9yksUBl.js';
import '../Order-lhrHRsf7.js';
import '../OrderContent-Lj2pNAI8.js';
import '../OrderItem-czbIAveW.js';
import '../Accordion-pLCj-Xix.js';
import '../AccordionItem-NVIeNZHk.js';
import '../AccordionTitle-elVPmO1F.js';
import '../EditCart-HjEL9CgI.js';
import '../OrderSkeleton-rqISrAex.js';
import '../OrderItemSkeleton-jJMEMLk8.js';
import '../SetPaymentMethodAndPlaceOrder-wmczr-yz.js';
import '../AllNumber-81uklFgf.js';
import './accor/AllNumber/form/index.js';
import '../InvalidShipping-faGATUsn.js';
import '../OrderInfo-3bdxPB_c.js';
import '../OrderItems--V3oK5sm.js';
import '../OrderForm-iNnMPsV0.js';
import './PostCheckout/ManualOrder/OrderForm/form/index.js';
import '../Order-oV2_6KS9.js';
import '../ShippingAddress-FeQ7dTHG.js';
import '../BankTransferInfo-FMhshJRT.js';
import '../GetGuestOrderManually-hdJjsTXW.js';
import '../ProcessPendingOrder-U4YVJScY.js';
import '../marriottTransaction-1QGY3vzu.js';
import '../purchase-j0II6Zcj.js';
import '../HotelSelector-QG0MenBm.js';
import './HotelSelector/form/index.js';
import '../Saved-7xzyYTEc.js';
import '../services/graphql/hotelSelector/index.js';
import '../BonvoyNumber-smiYBrsu.js';
import './BonvoyNumber/form/index.js';
import '../ApplyBonvoyNumberToOrder-jQREbEtd.js';
import '../services/accorAfilliateProgram/index.js';
import '../ActionBar-IbNMwKw8.js';
import '../MobileMenu-qaAhGm1g.js';
import '../storeSelectors/modal.js';
import '../hooks/useAuthenticated.js';
import '../SkipNavigation-wioCm4mt.js';
import '../MyAccount-Prx9NKfk.js';
import './SignUpUpdatesForm/form/index.js';
import '../TriggerValidation-EwWymetQ.js';
import 'next/head';
import '../store/currencies/index.js';
import '../store/genericSlice.js';
import '../store/currencies/thunks.js';
import '../GetCurrencies-HOmikd_V.js';
import '../store/currencies/initialState.js';
import '../Navigation-_wagbLKq.js';
import '../store/user/thunks.js';
import '../GenerateCustomerToken-nBNO7Rhh.js';
import '../GetCustomerInfo-QRC3rgNh.js';
import '../register-J9OaMUYD.js';
import '../utils/wishlist.js';
import '../store/wishlist/thunks.js';
import '../RemoveProductsFromWishlist-WCaYiZlq.js';
import '../wishlist-foOHzuD7.js';
import '../utils/parseJSON.js';
import '../store/wishlist/index.js';
import '../utils/transformWishlistModel.js';
import '../store/wishlist/initialState.js';
import '../hooks/useGetPageClass.js';

const VideoCover = ({ title, hide }) => (React.createElement("div", { className: classnames('video-cover', { hidden: hide }) },
    React.createElement("p", { className: "title" }, title),
    React.createElement("i", { className: "video-icon icon-play" })));

const PlayButton = ({ onClick, isPlaying }) => {
    const { t: tVideo } = useTranslation('', { keyPrefix: '$common.$videoPlayer' });
    return (React.createElement("button", { onClick: onClick, type: "button", "aria-label": tVideo('play'), className: "control-button" },
        React.createElement("i", { className: classnames('video-icon icon-play playback-icon', {
                'hidden-none': isPlaying,
            }) }),
        React.createElement("i", { className: classnames('video-icon icon-pause playback-icon', {
                'hidden-none': !isPlaying,
            }) })));
};

const TimeProgress = ({ currentTime, totalTime }) => {
    const { minutes: totalMinutes, seconds: totalSeconds } = totalTime;
    const { minutes: currentMinutes, seconds: currentSeconds } = currentTime;
    return (React.createElement("div", { className: "time" },
        React.createElement("time", null,
            currentMinutes,
            ":",
            currentSeconds),
        React.createElement("span", null, " \u00A0/\u00A0 "),
        React.createElement("time", null,
            totalMinutes,
            ":",
            totalSeconds)));
};

const VolumeControls = ({ showVolume, videoRef, setShowVolume, toggleMute, isMuted }) => {
    const volumeRef = useRef(null);
    const [volume, setVolume] = useState(1);
    const { t: tVideo } = useTranslation('', { keyPrefix: '$common.$videoPlayer' });
    const volumeInactivity = () => {
        let volumeTimer;
        let isVolumeHovered;
        const conditionalVolumeHiding = () => {
            if (!isVolumeHovered) {
                setShowVolume(false);
            }
        };
        const resetVolumeTimer = () => {
            clearTimeout(volumeTimer);
            volumeTimer = setTimeout(conditionalVolumeHiding, 500);
        };
        document.onmousemove = resetVolumeTimer;
        volumeRef.current.onmouseenter = () => {
            isVolumeHovered = true;
        };
        volumeRef.current.onmouseleave = () => {
            isVolumeHovered = false;
        };
    };
    const handleVolumeUpdate = (e) => {
        const video = videoRef.current;
        const newVolume = Number(e.target.value);
        setVolume(newVolume);
        video.volume = newVolume;
        if (video.muted || video.volume === 0) {
            toggleMute();
        }
    };
    useEffect(() => {
        volumeInactivity();
    }, []);
    return (React.createElement("div", { className: "volume-controls", ref: volumeRef },
        React.createElement("input", { className: classnames('volume video-input volume-bar', {
                'transition-opacity': showVolume,
            }), onInput: handleVolumeUpdate, "aria-label": tVideo('volume'), value: volume, type: "range", max: "1", min: "0", step: "0.01" }),
        React.createElement("button", { "aria-label": tVideo('mute'), type: "button", onMouseOver: () => setShowVolume(true), onFocus: () => setShowVolume(true), onClick: toggleMute, className: "volume-button control-button", "data-event-name": "bloc_interact", "data-bloc-name": `Video ${isMuted ? 'mute' : 'unmute'}` },
            React.createElement("i", { className: classnames('video-icon icon-volume', { 'hidden-none': !isMuted }) }),
            React.createElement("i", { className: classnames('video-icon icon-mute', { 'hidden-none': isMuted }) }))));
};

const FullscreenButton = ({ handleFullscreen }) => {
    const { t: tVideo } = useTranslation('', { keyPrefix: '$common.$videoPlayer' });
    return (React.createElement("button", { className: "control-button", type: "button", "aria-label": tVideo('fullScreen'), onClick: handleFullscreen, "data-event-name": "bloc_interact", "data-bloc-name": "Video enlarge" },
        React.createElement("i", { className: "video-icon icon-full-screen" })));
};

const ProgressBar = ({ handleProgress, currentTime, videoDuration }) => {
    const { t: tVideo } = useTranslation('', { keyPrefix: '$common.$videoPlayer' });
    return (React.createElement("div", { className: "video-progress" },
        React.createElement("input", { className: "seek video-input", onInput: handleProgress, "aria-label": tVideo('seek'), value: currentTime, min: "0", max: videoDuration, type: "range", step: "1", "data-event-name": "bloc_interact", "data-bloc-name": "Video progress" })));
};

const AutoPlay = ({ videoRef, headerOffset = 0, togglePlay }) => {
    const getVideoVisibleHeightCoefficient = (video) => {
        const videoRect = video.getBoundingClientRect();
        const videoHeight = videoRect.height;
        const videoTopOffset = videoRect.top - headerOffset;
        const windowHeight = window.innerHeight - headerOffset;
        let videoVisibleCoefficient;
        if (videoHeight === 0) {
            return 0;
        }
        if (videoTopOffset >= 0) {
            videoVisibleCoefficient = (windowHeight - videoTopOffset) / videoHeight;
        }
        else {
            videoVisibleCoefficient = Math.min(videoHeight + videoTopOffset, windowHeight) / videoHeight;
        }
        if (videoVisibleCoefficient < 0) {
            videoVisibleCoefficient = 0;
        }
        if (videoVisibleCoefficient > 1) {
            videoVisibleCoefficient = 1;
        }
        return videoVisibleCoefficient;
    };
    const onScroll = () => {
        const video = videoRef.current;
        // Do not auto-play video when it was ended
        if (!video || video.ended)
            return;
        const minVideoVisibleHeightCoefficient = 0.8; // Play when 80% of the player height is visible.
        const videoVisibleHeightCoefficient = getVideoVisibleHeightCoefficient(video);
        if (videoVisibleHeightCoefficient > minVideoVisibleHeightCoefficient) {
            video.play();
            togglePlay(true);
        }
        else {
            video.pause();
            togglePlay(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, []);
    return null;
};

const formatTime = (timeInSeconds) => {
    const time = Number.isNaN(timeInSeconds) ? 0 : timeInSeconds;
    const result = new Date(time * 1000).toISOString().substring(19, 14);
    return {
        minutes: result.substring(2, 0),
        seconds: result.substring(6, 3),
    };
};
const VideoPlayer = ({ src, coverTitle, showVolumeControls = true, showPlayButton = true, showTimeProgress = true, showProgress = true, showFullscreenButton = true, mobileBreakpoint, autoPlay = false, headerOffset = 0, ...rest }) => {
    const videoRef = useRef(null);
    const isPlayingRef = useRef(false);
    const muted = autoPlay;
    const [videoDuration, setVideoDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    // TODO: it looks that the <VolumeControl /> component may have an incorrect reverted usage
    // of the "isMuted" prop
    // That's why we need to use here the reverted "!muted" prop
    const [isMuted, setIsMuted] = useState(!muted);
    const [hasAlreadyPlayed, setHasAlreadyPlayed] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const isMobile = useWindowSize().width < (mobileBreakpoint || 660);
    const [showControls, setShowControls] = useState(false);
    const [showVolume, setShowVolume] = useState(false);
    const [transitioning, setTransitioning] = useState(false);
    const { manualUserClickHandler } = useUserInteractionEvent();
    const totalTimeObj = formatTime(videoDuration);
    const currentTimeObj = formatTime(currentTime);
    let time;
    const handleShowControls = () => {
        if (hasAlreadyPlayed) {
            setShowControls(true);
            setTimeout(() => {
                setTransitioning(false);
            }, 500);
        }
    };
    const togglePlay = () => {
        if (isMobile && !showControls) {
            handleShowControls();
            return;
        }
        const video = videoRef.current;
        let blocName = '';
        if (video.paused || video.ended) {
            video.play();
            blocName = 'Video Play';
            setIsPlaying(true);
        }
        else {
            video.pause();
            blocName = 'Video Pause';
            setIsPlaying(false);
        }
        manualUserClickHandler('bloc_interact', {
            bloc_name: blocName,
        });
    };
    const toggleMute = () => {
        const video = videoRef.current;
        video.muted = !video.muted;
        setIsMuted(val => !val);
    };
    const handleProgress = (e) => {
        const newCurrentTime = Number(e.target.value);
        setCurrentTime(newCurrentTime);
        videoRef.current.currentTime = newCurrentTime;
    };
    const handleTimeUpdate = () => {
        setCurrentTime(Math.floor(videoRef.current.currentTime));
    };
    const handleFullscreen = () => {
        const video = videoRef.current;
        if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        }
        else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
        }
    };
    const handleHideControls = () => {
        if (hasAlreadyPlayed && !transitioning && isPlayingRef.current) {
            setTransitioning(true);
            setShowControls(false);
            setShowVolume(false);
            setTimeout(() => {
                setTransitioning(false);
            }, 500);
        }
    };
    const inactivityTime = () => {
        if (hasAlreadyPlayed && isPlaying) {
            clearTimeout(time);
            time = setTimeout(handleHideControls, 2000);
        }
    };
    const handleOnPlay = () => {
        isPlayingRef.current = true;
        setHasAlreadyPlayed(true);
        handleHideControls();
    };
    const handleOnPause = () => {
        isPlayingRef.current = false;
        handleShowControls();
    };
    const handleOnEnded = () => {
        manualUserClickHandler('bloc_interact', {
            bloc_name: 'Video ended',
        });
    };
    const videoCoverKeyDown = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
            togglePlay();
        }
        if (e.key === 'm' || e.key === 'M') {
            e.preventDefault();
            toggleMute();
        }
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const newCurrentTime = currentTime - 1;
            setCurrentTime(newCurrentTime);
            videoRef.current.currentTime = newCurrentTime;
        }
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            const newCurrentTime = currentTime + 1;
            setCurrentTime(newCurrentTime);
            videoRef.current.currentTime = newCurrentTime;
        }
        if (e.key === 'f' || e.key === 'F') {
            e.preventDefault();
            handleFullscreen();
        }
    };
    useEffect(() => {
        if (!coverTitle) {
            setShowControls(true);
        }
        if (videoRef.current.readyState >= 1) {
            setVideoDuration(Math.round(videoRef.current.duration));
        }
        setTimeout(() => {
            setVideoDuration(Math.round(videoRef.current.duration));
        }, 150);
    }, [videoRef]);
    return (React.createElement("div", { className: "video-player-wrapper", onMouseMove: handleShowControls, onMouseLeave: handleHideControls },
        coverTitle && React.createElement(VideoCover, { title: coverTitle, hide: hasAlreadyPlayed }),
        React.createElement("video", { className: "main-video", tabIndex: 0, onClick: togglePlay, onMouseMove: inactivityTime, onPlay: handleOnPlay, onPause: handleOnPause, onEnded: handleOnEnded, onTimeUpdate: handleTimeUpdate, onKeyDown: videoCoverKeyDown, onLoadedMetadata: () => setVideoDuration(Math.round(videoRef.current.duration)), ref: videoRef, preload: "metadata", playsInline: true, muted: muted, ...rest },
            React.createElement("track", { default: true, kind: "captions" }),
            React.createElement("source", { src: src, type: "video/mp4" })),
        React.createElement("div", { className: classnames('video-controls', { 'transition-opacity': showControls }) },
            React.createElement("div", { className: "video-controls-top" },
                React.createElement("div", { className: "play-wrapper" },
                    showPlayButton && React.createElement(PlayButton, { onClick: togglePlay, isPlaying: isPlaying }),
                    showTimeProgress && (React.createElement(TimeProgress, { currentTime: currentTimeObj, totalTime: totalTimeObj }))),
                React.createElement("div", { className: "video-controls-right" },
                    showVolumeControls && (React.createElement(VolumeControls, { showVolume: showVolume, videoRef: videoRef, setShowVolume: setShowVolume, toggleMute: toggleMute, isMuted: isMuted })),
                    showFullscreenButton && React.createElement(FullscreenButton, { handleFullscreen: handleFullscreen }))),
            showProgress && (React.createElement(ProgressBar, { handleProgress: handleProgress, currentTime: currentTime, videoDuration: videoDuration }))),
        autoPlay && (React.createElement(AutoPlay, { videoRef: videoRef, headerOffset: headerOffset, togglePlay: play => setIsPlaying(play) }))));
};

const SignUpUpdates = ({ privacyPolicy, variant, privacySubtitle }) => {
    const [isShowForm, setIsShowForm] = useState(true);
    const { pathname } = useRouter();
    const { t } = useTranslation('', { keyPrefix: '' });
    const { data: { siteConfig: { footer: { hahSubscribeCheckbox = false, brandSubscribeCheckbox = false, accorSubscribeCheckbox = false, inlineSubscribeHeading = false, } = {}, }, }, } = useContext(CoreContext);
    if (!privacyPolicy) {
        logger('Error getting "privacyPolicy" data; check BO configuration for the "footer" block', {
            type: 'error',
        });
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(`footer-email-signup ${variant}`, {
                'sign-up-updates-hide': !isShowForm || pathname.includes('checkout'),
            }) },
            React.createElement(SignUpUpdatesForm, { onSuccessCallback: () => setIsShowForm(false), privacyPolicy: privacyPolicy, className: "clearfix", label: "footerSignupEmail", position: "footer", subscribeBtnText: t('$common.$buttons.subscribeBtnSecondary'), hahSubscribeCheckbox: hahSubscribeCheckbox, brandSubscribeCheckbox: brandSubscribeCheckbox, accorSubscribeCheckbox: accorSubscribeCheckbox, inlineSubscribeHeading: inlineSubscribeHeading, privacySubtitle: privacySubtitle })),
        React.createElement(ConditionalWrapper, { condition: privacySubtitle, wrapper: React.createElement("div", { className: "sign-up-updates-confirm-wrapper" }) },
            React.createElement("p", { className: classnames('sign-up-updates-confirm', 'font-sub-heading-bold', {
                    'sign-up-updates-confirm-show': !isShowForm,
                }), dangerouslySetInnerHTML: { __html: t('$common.subscriptionMsg') }, role: "alert" }))));
};
var SignUpUpdates$1 = withProviders(SignUpUpdates, { translation: true });

const BottomFooterLinks = ({ bottomFooterLinksData, isMarriotSite = false, }) => {
    const { locale } = useRouter();
    const { data: { siteConfig: { footer: { ctaBlackLinks = false } = {} }, }, } = useContext(CoreContext);
    const isExternalLink = (url) => url.includes('https://');
    const getUrl = (url) => (isExternalLink(url) ? url : `/${locale}${url}`);
    if (!bottomFooterLinksData) {
        logger('Failed to retrieve "bottomFooterLinks" data. Please verify the "footer" block configuration in the Back Office and ensure the API is operational.', { type: 'error' });
    }
    return (React.createElement("p", { id: "bottomFooterLinks" },
        bottomFooterLinksData &&
            bottomFooterLinksData.map((item, index) => (React.createElement(Link, { href: getUrl(item.url), title: item.title, className: "useful-links__link", key: `${item.title + index}`, black: ctaBlackLinks, noUnderline: true, target: (isExternalLink(item.url) || item.newTab) && '_blank' },
                React.createElement("span", { "data-event-name": "bloc_interact", "data-bloc-name": `${item.title}` }, item.title)))),
        isMarriotSite && React.createElement("span", { id: "teconsent" })));
};

const TopFooterLinks = ({ customerSupportLinks, chatSiteId, zendeskKey }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { locale } = useRouter();
    const showError = useShowError();
    const { data: { siteConfig: { csrEmail }, }, } = useContext(CoreContext);
    const chatLiveLink = (chatId) => chatSiteId ? `https://lc.chat/now/${chatSiteId}/${chatId}` : '#';
    if (!customerSupportLinks) {
        logger('Error getting "customerSupportLinks" data; check BO configuration for the "footer" block', { type: 'error' });
        return null;
    }
    const openChat = (e, chatId) => {
        e.preventDefault();
        if (chatId && typeof window !== 'undefined') {
            window.open(chatLiveLink(chatId), 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=500,height=500');
        }
        else {
            showError(t('$common.$validation.chatNowError', { csrEmail }));
        }
    };
    const handleKeyDown = (e, chatId) => {
        if (e.key === 'enter') {
            openChat(e, chatId);
        }
    };
    const handleChatTriggerClick = () => {
        try {
            if (window.zE) {
                window.zE('messenger', 'open');
            }
            else {
                console.error('Zendesk Web Widget is not initialized.');
            }
        }
        catch (error) {
            console.error('Error opening Zendesk Web Widget:', error);
        }
    };
    const buildItems = (item, index) => {
        switch (item.name) {
            case 'phone':
                return (React.createElement(Link, { key: `${item.name + index}`, href: `tel:${item.value}`, className: `icon-phone top-footer-item item-${index + 1}`, ariaLabel: "Phone Number", black: true, noUnderline: true },
                    React.createElement("span", { "data-event-name": "bloc_interact", "data-bloc-name": item.altTitle || item.title }, item.altTitle || item.value)));
            case 'chat':
                if (!chatSiteId && !zendeskKey)
                    return null;
                if (zendeskKey) {
                    return (React.createElement("span", { key: "zendesk-chat", className: `chat-trigger icon-chat top-footer-item item-${index + 1}`, onClick: handleChatTriggerClick, onKeyDown: handleChatTriggerClick, role: "button", tabIndex: 0 }, item.altTitle || item.title));
                }
                if (chatSiteId) {
                    return (React.createElement("a", { key: `${item.name + index}`, href: chatLiveLink(item.value), className: `chat-title icon-chat top-footer-item item-${index + 1}`, onClick: e => openChat(e, item.value), onKeyDown: e => handleKeyDown(e, item.value), "aria-label": `${item.title} - ${t('$common.$ariaLabels.newWindow')}` },
                        React.createElement("span", { "data-event-name": "bloc_interact", "data-bloc-name": item.altTitle || item.title }, item.altTitle || item.title)));
                }
                return null;
            case 'faq':
                return (React.createElement(Link, { key: `${item.name + index}`, href: `/${locale}${item.value}`, title: item.title, className: `icon-faq top-footer-item item-${index + 1}`, black: true, noUnderline: true },
                    React.createElement("span", { "data-event-name": "bloc_interact", "data-bloc-name": item.altTitle || item.title }, item.altTitle || item.title)));
            case 'contact-us':
                return (React.createElement(Link, { key: `${item.name + index}`, href: `/${locale}${item.value}`, title: item.title, className: `icon-email top-footer-item item-${index + 1}`, black: true, noUnderline: true },
                    React.createElement("span", { "data-event-name": "bloc_interact", "data-bloc-name": item.altTitle || item.title }, item.altTitle || item.title)));
            default:
                return item.title;
        }
    };
    return (React.createElement("div", { className: "footer-links" },
        customerSupportLinks.title && (React.createElement("h2", { className: "contact-links-title font-sub-heading-bold" }, customerSupportLinks.title)),
        React.createElement("div", { className: "support" },
            React.createElement("div", { className: "top-footer-items clearfix" }, customerSupportLinks.items.map((item, index) => buildItems(item, index))))));
};

const OtherHotelSites = ({ otherHotelSites }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    if (!otherHotelSites) {
        logger('Error getting "otherHotelSites" data; check BO configuration for the "footer" block', {
            type: 'error',
        });
        return null;
    }
    const otherHotelsCount = otherHotelSites.length;
    const isOdd = otherHotelsCount % 2 !== 0 ? 'odd' : 'even';
    return (React.createElement("div", { className: "all-sites", id: "otherHotelSites" },
        React.createElement("h2", { className: "tlt-footer font-sub-heading", dangerouslySetInnerHTML: { __html: t('$common.$headings.otherSites') } }),
        React.createElement("div", { className: `all-sites-list-wrapper ct-${otherHotelsCount} ${isOdd}` }, otherHotelSites.map((item, index) => (React.createElement(Link, { href: item.url, ariaLabel: t('$common.visitOtherSite', { siteName: item.title }), target: "_blank", key: `${item.title + index}`, className: "all-sites-item font-body-small", noUnderline: true, "data-event-name": "bloc_interact", "data-bloc-name": item.title }, item.title))))));
};

const defaultAcceptedPayments = [
    'cb',
    'visa',
    'mastercard',
    'amex',
    'bank-transfer',
    'paypal',
    'alma',
    'apple-pay',
    'google-pay',
];
const AcceptedPayments = ({ displayAcceptedPayments = defaultAcceptedPayments, }) => (React.createElement("ul", { className: "footer-payments" }, displayAcceptedPayments.map(item => (React.createElement("li", { key: item },
    React.createElement("span", { className: "sr-only" }, item),
    React.createElement("i", { className: item }))))));

export { AcceptedPayments, BottomFooterLinks, Link, OtherHotelSites, SignUpUpdates$1 as SignUpUpdates, SignUpUpdatesForm, TopFooterLinks, VideoPlayer };
//# sourceMappingURL=index.js.map
